<template>
    <span>
        <b-dropdown v-if="date" size="sm" variant="transparent" toggle-class="text-decoration-none" no-caret>
            <template #button-content>
                <b-icon-calendar variant="dark"/>
            </template>
            <b-dropdown-item :href="googleUrl" target="_blank">Add to Google calendar</b-dropdown-item>
            <b-dropdown-item :href="microsoftUrl" target="_blank">Add to Microsoft Live calendar</b-dropdown-item>
            <b-dropdown-item :href="office365Url" target="_blank">Add to Office365 Outlook calendar</b-dropdown-item>
        </b-dropdown>
    </span>
</template>

<script>
export default {
    name: 'CalendarAdd',
    props: {
        title: String,
        date: String,
        details: String
    },
    data () {
        return {}
    },
    computed: {
        dateStart () {
            if (this.date) {
                let dateStart = new Date(Date.parse(this.date))
                dateStart.setHours(0, 0, 0, 0)
                return dateStart
            } else {
                return null
            }
        },
        dateEnd () {
            if (this.dateStart) {
                let dateEnd = new Date(this.dateStart)
                dateEnd.setDate(this.dateStart.getDate() + 1)
                return dateEnd
            } else {
                return null
            }
        },
        googleUrl () {
            return this.calendarUrl(
                'https://calendar.google.com/calendar/render?action=TEMPLATE',
                {
                    text: this.formatString(this.title),
                    details: this.formatString(this.details),
                    dates: this.formatDate(this.dateStart, '') + '/' + this.formatDate(this.dateEnd, ''),
                    trp: true
                })
        },
        microsoftUrl () {
            return this.calendarUrl(
                'https://outlook.live.com/owa/?rru=addevent',
                {
                    subject: this.formatString(this.title),
                    body: this.formatString(this.details),
                    startdt: this.formatDate(this.dateStart),
                    enddt: this.formatDate(this.dateEnd)
                })
        },
        office365Url () {
            return this.calendarUrl(
                'https://outlook.office.com/owa/?path=/calendar/action/compose&rru=addevent',
                {
                    subject: this.formatString(this.title),
                    body: this.formatString(this.details),
                    startdt: this.formatDate(this.dateStart),
                    enddt: this.formatDate(this.dateEnd)
                })
        }
    },
    methods: {
        calendarUrl (url, parameters) {
            let result = url
            for (const key in parameters) {
                if (parameters[key]) {
                    result += `&${key}=${parameters[key]}`
                }
            }
            return result
        },
        formatString (string) {
            return encodeURIComponent(string).replace(/%20/g, '+')
        },
        formatDate (date, spacer = '-') {
            if (date) {
                return [
                    date.getFullYear(),
                    ('0' + (date.getMonth() + 1)).slice(-2),
                    ('0' + date.getDate()).slice(-2)
                ].join('')
            } else {
                return ''
            }
        }

    }
}
</script>
